import { emailRegex } from "@/utils/regex";
import type { ISendToCustomerContactState } from "./types";

const validateSendToCustomerContact = (
  state: ISendToCustomerContactState,
  t: (key: string) => string
): string | null => {
  if (!state.sendBySms && !state.sendByMail && !state.sendByWhatsapp) {
    return t("alerts.checkAtLeastOne");
  }

  if (state.sendByMail && !state.contactMail?.trim()) {
    return t("alerts.noMail");
  }

  if (state.sendByMail && !emailRegex.test(state.contactMail.trim())) {
    return t("customers.invalidEmail");
  }

  if (
    state.additionalEmailCc?.trim() &&
    !emailRegex.test(state.additionalEmailCc.trim())
  ) {
    return t("customers.invalidEmail");
  }

  if ((state.sendBySms || state.sendByWhatsapp) && !state.contactPhone?.trim()) {
    return t("alerts.noPhoneNumber");
  }

  return null;
};

export { validateSendToCustomerContact };
